import ContactForm from "@/components/base/ContactForm";
import ContactInfo from "@/components/base/ContactInfo";

export default function Formulaire() {
  return (
    <section id="devis" className="bg-brand-light py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 md:gap-8 lg:gap-10 min-w-0">
          <ContactForm
            page="Contact"
            subject="Nouveau lead Dépan'Volets — Contact"
            title="Envoyez-nous un message"
            variant="wide"
            showTitle
          />
          <ContactInfo variant="dark" />
        </div>
      </div>
    </section>
  );
}